import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'models/store';

// ==============================|| DELIVERY POINT SELECTORS ||============================== //

export const selectDeliveryPointList = (state: RootState) =>
  state.eai.deliveryPoint.deliveryPointList.deliveryPointList;

export const selectDeliveryPointListPage = (state: RootState) =>
  state.eai.deliveryPoint.deliveryPointList.page;

export const selectDeliveryPointDetail = (state: RootState) =>
  state.eai.deliveryPoint.deliveryPointDetail;

export const selectDeliveryPointWithIdCheck = createSelector(
  [
    selectDeliveryPointDetail,
    (_, expectedId: string | undefined) => expectedId
  ],
  (deliveryPoint, expectedId: string | undefined) => {
    if (
      deliveryPoint != null &&
      expectedId != null &&
      deliveryPoint.id === expectedId
    ) {
      return deliveryPoint;
    }
    return undefined;
  }
);

export const selectDeliveryPointCharacteristics = (state: RootState) =>
  state.eai.deliveryPoint.deliveryPointCharacteristics;

export const selectDeliveryPointGDSList = (state: RootState) =>
  state.eai.deliveryPoint.gdsList;

export const selectDeliveryPointGDSDetail = (state: RootState) =>
  state.eai.deliveryPoint.gdsDetail;

export const selectDeliveryPointAssignmentsList = (state: RootState) =>
  state.eai.deliveryPoint.assignments;

export const selectDeliveryPointGDSDevicesList = (state: RootState) =>
  state.eai.deliveryPoint.gdsDevicesList;

export const selectShowGdsDetail = (state: RootState) =>
  state.eai.deliveryPoint.showGdsDetail;
